import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TooltipDirective } from '../../tooltip/tooltip.directive';

@Component({
  selector: 'andor-icon-btn',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, TooltipDirective],
  templateUrl: './icon-btn.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './icon-btn.scss',
})
export class IconBtn {
  @Input() disabled = false;
  @Input() tooltip = '';
  @Input('aria-label') ariaLabel = '';
  @Output() clickHandler = new EventEmitter<MouseEvent>();

  @HostListener('click', ['$event'])
  onHostClick(event: Event) {
    if (this.disabled) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }

  emitClick(event: MouseEvent) {
    if (this.disabled) return;
    this.clickHandler.emit(event);
  }
}
